// extracted by mini-css-extract-plugin
module.exports = {"container":"BasicLayout--container--XGu81wV"};